import { ObjectUtils } from "../object-utils";
export class NullUtils {
    static deepNullToUndefined(value) {
        if (value === null) {
            return undefined;
        }
        if (!ObjectUtils.isObject(value)) {
            return value;
        }
        let result = {};
        Object.keys(value).forEach((key) => {
            const target = value[key];
            result = {
                ...result,
                [key]: NullUtils.deepNullToUndefined(target),
            };
        });
        return result;
    }
    static nonNullable(value) {
        return value !== null && value !== undefined;
    }
    static ifNullable(value, fill) {
        return NullUtils.nonNullable(value) ? value : fill;
    }
}
//# sourceMappingURL=null-utils.js.map